<template>
    <a-button
        :disabled="disabled"
        :class="className"
        :loading="loading"
        @click="flushPageView"
        type="default"
        htmlType="button"
    >
        <!-- 插槽 类似于React中的this.props.children -->
        <slot></slot>
    </a-button>
</template>

<script>
export default {
    methods: {
        //刷新页面视图
        flushPageView() {
            if (this.redirect !== false) {
                //判断页面是否需要跳转
                this.$router.push({
                    ...this.redirect
                });
            } else {
                //如果页面不需要跳转   直接更新下视图即可
                this.G.flushRightContent();
            }
        }
    },
    props: {
        loading: {
            //loading加载效果
            default: false,
            type: Boolean
        },
        disabled: {
            //按钮禁用状态
            default: false,
            type: Boolean
        },
        className: {
            //额外的样式   注意: 好像不能定义为class?
            default: "",
            type: String
        },
        redirect: {
            //页面是否需要跳转
            default: false
        }
    }
};
</script>

<style scoped>
</style>